// extracted by mini-css-extract-plugin
export default {"sideBanners":"SideBanners_sideBanners__fX8Eu","timerWrapper":"SideBanners_timerWrapper__4eejh","banner":"SideBanners_banner__r18WV","image":"SideBanners_image__0LLu1"};